import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BooleanParam, NumberParam, StringParam, useQueryParam } from 'use-query-params';
import { Button, LinearProgress, ListItem, ListItemText, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel } from '@material-ui/core';
import { AppSnackbar, MoreButtonMenu, PageTemplate, PageTemplateCardOver, PageTemplateHeader, PageTemplateHeaderActions, SearchBox } from '@sierralabs/core-ui';
import FormTemplateCreateDialog from './dialogs/FormTemplateCreateDialog';
import { useFindFormTemplates } from './FormTemplate.hooks';
import { format } from 'date-fns';
import { PublishStatusLabels } from './common';
export const FormTemplateListPage = ({ label = 'Form Template' }) => {
    const [search = '', setSearch] = useQueryParam('search', StringParam);
    const [page = 0, setPage] = useQueryParam('page', NumberParam);
    const [limit = 100, setLimit] = useQueryParam('limit', NumberParam);
    const [order = 'created', setOrder] = useQueryParam('order', StringParam);
    const [direction = 'DESC', setDirection] = useQueryParam('direction', StringParam);
    const [includeDeleted, setIncludeDeleted] = useQueryParam('includeDeleted', BooleanParam);
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const history = useHistory();
    const { formTemplateList, loadingFormTemplates, loadingFormTemplatesError, findFormTemplates } = useFindFormTemplates();
    useEffect(() => {
        findFormTemplates({
            search,
            page,
            limit,
            order,
            direction,
            includeDeleted
        });
    }, [
        page,
        limit,
        order,
        direction,
        findFormTemplates,
        search,
        includeDeleted
    ]);
    const handleSort = (column) => {
        setOrder(column);
        setDirection(direction === 'ASC' ? 'DESC' : 'ASC');
    };
    const getSortDirection = (column) => {
        return order === column && direction === 'DESC' ? 'desc' : 'asc';
    };
    return (React.createElement(PageTemplate, null,
        React.createElement(PageTemplateHeader, null,
            React.createElement("h2", null, label),
            React.createElement(SearchBox, { value: search || '', onSearch: setSearch }),
            React.createElement(PageTemplateHeaderActions, null,
                React.createElement(Button, { variant: 'contained', color: 'primary', onClick: () => setIsOpenDialog(true) },
                    "Add ",
                    label),
                React.createElement(MoreButtonMenu, null,
                    React.createElement(ListItem, { button: true, onClick: () => setIncludeDeleted(!includeDeleted) },
                        React.createElement(ListItemText, { primary: `${includeDeleted ? 'Hide' : 'Show'} Deleted` }))))),
        React.createElement(PageTemplateCardOver, null,
            React.createElement(TableContainer, null,
                React.createElement(Table, { stickyHeader: true },
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, null,
                                React.createElement(TableSortLabel, { active: order === 'formTemplate.id', direction: getSortDirection('formTemplate.id'), onClick: () => handleSort('formTemplate.id') }, "ID")),
                            React.createElement(TableCell, null,
                                React.createElement(TableSortLabel, { active: order === 'formTemplate.name', direction: getSortDirection('formTemplate.name'), onClick: () => handleSort('formTemplate.name') }, label)),
                            React.createElement(TableCell, null,
                                React.createElement(TableSortLabel, { active: order === 'formTemplate.status', direction: getSortDirection('formTemplate.status'), onClick: () => handleSort('formTemplate.status') }, "Status")),
                            React.createElement(TableCell, null,
                                React.createElement(TableSortLabel, { active: order === 'formTemplate.modified', direction: getSortDirection('formTemplate.modified'), onClick: () => handleSort('formTemplate.modified') }, "Last Modified")),
                            React.createElement(TableCell, null,
                                React.createElement(TableSortLabel, { active: order === 'modifiedBy.firstName', direction: getSortDirection('modifiedBy.firstName'), onClick: () => handleSort('modifiedBy.firstName') }, "Modified By")))),
                    React.createElement(TableBody, null,
                        loadingFormTemplates && (React.createElement(TableRow, null,
                            React.createElement(TableCell, { colSpan: 5, padding: 'none' },
                                React.createElement(LinearProgress, null)))),
                        formTemplateList &&
                            formTemplateList.data.map((formTemplate) => {
                                var _a, _b;
                                return (React.createElement(TableRow, { hover: true, key: formTemplate.id, className: formTemplate.isDeleted ? 'deleted' : '', onClick: () => history.push(`/portal/admin/form-templates/${formTemplate.id}/info`) },
                                    React.createElement(TableCell, null, formTemplate.id),
                                    React.createElement(TableCell, null, formTemplate.name),
                                    React.createElement(TableCell, null,
                                        React.createElement(PublishStatusLabels, { status: formTemplate.status, version: formTemplate.version })),
                                    React.createElement(TableCell, null, format(formTemplate.modified, 'MMM d, yyyy h:mm a')),
                                    React.createElement(TableCell, null, (_a = formTemplate.modifiedBy) === null || _a === void 0 ? void 0 :
                                        _a.firstName,
                                        ' ', (_b = formTemplate.modifiedBy) === null || _b === void 0 ? void 0 :
                                        _b.lastName)));
                            }))),
                React.createElement(TablePagination, { component: 'div', rowsPerPageOptions: [10, 25, 100], count: (formTemplateList === null || formTemplateList === void 0 ? void 0 : formTemplateList.total) || 0, rowsPerPage: limit || 100, page: page || 0, onPageChange: (_, newPage) => setPage(newPage), onRowsPerPageChange: event => {
                        setLimit(+event.target.value);
                        setPage(0);
                    } }))),
        React.createElement(AppSnackbar, { severity: 'error', open: Boolean(loadingFormTemplatesError) }, "There was an error loading the list of formTemplates."),
        isOpenDialog && (React.createElement(FormTemplateCreateDialog, { open: isOpenDialog, onCancel: () => setIsOpenDialog(false), onCreated: formTemplate => {
                setIsOpenDialog(false);
                history.push(`./form-templates/${formTemplate.id}`);
            } }))));
};
export default FormTemplateListPage;
//# sourceMappingURL=FormTemplateListPage.js.map